import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { CssClassMapping } from '../../../../core/configuration/css-class-mapping';
import { FrontEndMapping } from '../../../../core/configuration/front-end-mapping';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { HelpersService } from '../../../../core/services/helpers.service';
import { ModalNotifyService } from "../../../../core/services/modal-notify.service";
import { OperationsService } from '../../../../core/services/operations.service';
import { MappingTipiEntitaPratica } from "../../../configuration/mapping-tipi-entita-pratica";
import { Classificazione } from "../../../models/classificazione";
import { PraticaFullResponse } from '../../../models/dto/pratica-full-response';
import { PraticaLightResponse } from '../../../models/dto/pratica-light-response';
import { FascicoloLight } from '../../../models/fascicolo/fascicolo-light';
import { PraticaBase } from '../../../models/pratica/pratica-base';
import { SezioneControparti } from "../../../models/sezioni/sezione-controparti";

declare var removeEmptyObject: any;
declare var getFascicoloMapSync;
declare var getPraticaMapSync;
declare var closeModal: any;

@Component({
    selector: 'div [copia-pratica]',
  templateUrl: 'copia-pratica.component.html',
  styleUrls: ['./copia-pratica.component.css']
})

export class CopiaPraticaComponent{
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  pratica: PraticaBase;
  fascicoli: any[]; // FascicoloAnalitico[] | FascicoloLight[];
  fascicoliMapping: any[];
  dataInizioPratica: number;
  urlCopiaPratica: string;
  tipoPraticaClassCss: string;
  sezioni: SezioneControparti[] = [];
  classificazioni: Classificazione[] = [];
  loadInit: boolean;
  load: boolean;
  submitPending: boolean;
  noControparte: boolean[] = [];
  idFormPratica: string;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  ID_PRATICA_PARERISTICA = MappingTipiEntitaPratica.PRATICA_PARERISTICA;
  constructor(protected operationService: OperationsService,
              private campiForm: FormBuilder,
              private helpers: HelpersService,
              private router: Router, private frontEndMapping: FrontEndMapping,
              private modalNotifyService: ModalNotifyService) {
  }
  /*ngOnChanges() {
    // this.pratica = new PraticaBase();
    // this.fascicoli = new FascicoloLight();
    this.dataInizioPratica = null;
  }*/
  getUrlReadSezione(): string {
    return '/rs/ops/gp/' + this.pratica.tipoPratica.endpoint + '/prat/sez/classificazioni';
  }
  getUrlDetailFascicolo(endpoint): string {
    return '/rs/ops/gp/' + this.pratica.tipoPratica.endpoint + '/fasc/' + endpoint;
  }

  getUrlSezioniControparti(endpoint): string {
    return '/rs/ops/gp/' + this.pratica.tipoPratica.endpoint + '/fasc/' + endpoint + '/sez/controparti';
  }

  inizializza(praticaBase: PraticaBase) {
    this.pratica = praticaBase;
//    this.tipoPraticaClassCss = this.getClassPratica(this.pratica.tipoPratica.id);
    let praticaMap = this.getPraticaFromMap(this.pratica.tipoPratica.id);
    this.caricaFascicoli(praticaBase.id, praticaMap.pathView);
  }

  caricaFascicoli(idPratica: string, urlRead: string) {
    this.loadInit = true;
    this.operationService.readPratica(urlRead, idPratica).subscribe(response => this.getDati(response));
  }

  getDati(response: PraticaFullResponse) {
    if (response.returnCode === 'OK') {
      this.pratica = response.pratica;
      let numFascicoli = response.pratica.fascicoliLight.length;
      this.fascicoli = response.pratica.fascicoliLight;
      this.fascicoliMapping = response.pratica.fascicoliLight;
      if(this.pratica.idSezioneClassificazione) {
        this.operationService.readSezione(this.getUrlReadSezione(), this.pratica.idSezioneClassificazione).subscribe(resp => this.classificazioni = resp.sezione.classificazioni);
      }
    }
    this.loadInit = false;
  }

  loadSection(idFascicolo, endpoint) {
    if (this.sezioni[idFascicolo]) {
      return;
    }
    this.load = true;
    this.noControparte[idFascicolo] = false;
    this.operationService.readFascicolo(this.getUrlDetailFascicolo(endpoint), idFascicolo).subscribe(response => {
     if (response.fascicolo.idSezioneControparti) {
        this.operationService.readSezione(this.getUrlSezioniControparti(endpoint), response.fascicolo.idSezioneControparti)
          .subscribe(resp => {
            this.sezioni[idFascicolo] = resp.sezione;
            this.fascicoliMapping = this.fascicoliMapping.map(el => {
              if (el.id === idFascicolo) {
                return response.fascicolo;
              } else {
                return el;
              }
            });
            this.load = false;
          }, (err) => {
            this.load = false;
            console.log(err);
          });
      } else {
        this.load = false;
        this.noControparte[idFascicolo] = true;
      }
    });
  }

  aggiungiFascicolo(fascicolo) {
    if (!fascicolo.selected) { // fascicolo deselezionato -> rimuovo le controparti
      this.fascicoli[this.fascicoli.findIndex(el => el.id === fascicolo.id)].selectedAllControparti = false;
      this.aggiungiAllControparti({...fascicolo, selectedAllControparti: false});
    } else { // fascicolo selezionato -> aggiungo di defalut tutte le controparti
      this.fascicoli[this.fascicoli.findIndex(el => el.id === fascicolo.id)].selectedAllControparti = true;
      this.aggiungiAllControparti(fascicolo);
    }
  }

  aggiungiAllControparti(fascicolo) {
    this.sezioni[fascicolo.id].controparti = this.sezioni[fascicolo.id].controparti.map(el => {
        return {
          ...el,
          selected: fascicolo.selectedAllControparti
        };
    });
  }

  aggiungiControparte(fascicolo, controparte) {
    if (!controparte.selected) { // controparte deselezionato -> rimuovo selectedAllControparti
      this.fascicoli[this.fascicoli.findIndex(el => el.id === fascicolo.id)].selectedAllControparti = false;
    }
  }

  onSelectPrimario(controparte, idFascicolo) {
    this.sezioni[idFascicolo].controparti = this.sezioni[idFascicolo].controparti.map(el => {
          return {
            ...el,
            primario: el.id === controparte.id
          };
      });
  }

  disabledSubmit() {
    if (!this.fascicoli) {
      return true;
    }
    let fascicoli = [...this.fascicoli.filter(el => el.selected === true)];
    let checkControparte = true;
    for(let i = 0; i < fascicoli.length; i++) {
      const controparti = this.sezioni[fascicoli[i].id].controparti.filter(c => c.selected);
      if (!controparti || controparti.length === 0) {
        checkControparte = false;
        break;
      }
    }
    return !(this.dataInizioPratica && fascicoli.length > 0 &&  checkControparte);
  }

  copiaPratica() {
    // mapping request
    let fascicoli = [...this.fascicoliMapping.filter(el => {
      if (this.fascicoli.find(f => f.id === el.id).selected === true) {
        return {
          ...el
        };
      }
    })
    ];
    fascicoli = fascicoli.map(f => {
      return {
        ...f,
        id: null,
        idParent: null,
        intestazione: null,
        posizione: null,
        registroFascicolo: null,
        vecchiaPosizione: null,
        dataInizioFascicolo:this.dataInizioPratica,
        sezioneControparti: {
          controparti: this.sezioni[f.id].controparti.filter(c => c.selected).map(({selected, ...x}) => x).map(el => {
            return {
              ...el,
              id: null,
              documenti: []
            };
          })
        }
      };
    });
    fascicoli = fascicoli.map(({selected, selectedAllControparti, riassunto, praticaBase, copertina, idSezioneControparti,
                                 idSezioneAltreParti, idSezioneAtti, idSezioneDatiEconomici, idSezioneDocumentazioneAllegata,
                                 idSezioneEsiti, idSezioneFatture, idSezioneIncassi, idSezioneLegali, idSezionePagamenti,
                                 idSezioneParcelle, idSezioneScadenze, fascicoloCapofila, fascicoliRiuniti, autoritaGiudiziariaCitta,
                                 idSezioneBeniPignoratiMobili, idSezioneTitoliEsecutivi, idSezioneProveScritte, idSezioneBeniPignoratiImmobili,
                                 valorePrecettoDiRiferimento, numDecretoIngiuntivoRiferimento, valoreDecretoIngiuntivoRiferimento, valoreFascicoloRif,
                                 idSezioneLettereDiffida, dataApposizioneFormulaEsecutiva, idSezionePatologie, idSezioneCensimentoDocumenti, ...f}) => f);
    const request = {
      pratica: {
        ...this.pratica,
        id: null,
        stato: null,
        posizione: null,
        intestazione: null,
        idSezioneClassificazione: null,
        dataApertura: this.dataInizioPratica,
      },
      fascicoli: [...fascicoli],
      classificazione: {
        classificazioni: this.classificazioni.map(c => {
          return {
            ...c,
            id: null
          };
        })
      }
    };
    delete request.pratica['fascicoliLight'];
    console.log(request);
    // let fascicoloMap = this.getFascicoloFromMap(this.fascicoli.tipoFascicolo.id, this.pratica.tipoPratica.id);
    this.urlCopiaPratica = '/rs/ops/gp' + ServicePathsSettings.URL_COPIA_PRATICA;
    // this.pratica.dataApertura = this.dataInizioPratica;
    this.submitPending = true;
    request.fascicoli.forEach((el, i) => {
        delete request.fascicoli[i].idSezioneSchedeRecupero;
        delete request.fascicoli[i].idSezioneSchedeEsecuzione;
        if(request.fascicoli[i].metadata) {
          request.fascicoli[i].metadata.forEach((m) => m.joinId = null);
        }
    });
    //TSR-1526 fix copia metadati
    if(!!request.pratica['metadata']){
      request.pratica['metadata'].forEach((m) => m.joinId = null);
    }
    this.operationService.copiaPratica(this.urlCopiaPratica, request).subscribe(response => {
      this.submitPending = false;
      this.modalNotifyService.customMessage('Operazione effettuata con successo');
      this.datiCopiaPratica(response);
    }, (err) => {
      this.submitPending = false;
      console.log(err);
    });
  }

  datiCopiaPratica(response: PraticaLightResponse) {
    if (response.returnCode === 'OK') {
      // let nomePraticaFE = FrontEndMapping.tipiPratica[Number(response.pratiche.tipoPratica.id)];
      let nomePraticaFE = '';
      this.frontEndMapping.getListTipiPratica(response.pratica.tipoPratica.id).subscribe(res => {
        nomePraticaFE = res;
      });
      // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[Number(this.fascicoli.tipoFascicolo.id)];
      /*let nomeFascicoloFE = '';
      this.frontEndMapping.getListTipiFascicolo(this.fascicoli.tipoFascicolo.id).subscribe(res => {
        nomeFascicoloFE = res;
      });
      this.dataInizioPratica = null;*/
      closeModal('modalCopiaPratica');
      this.router.navigate(['/pratica/' + nomePraticaFE + '/view/' + response.pratica.id]);
    }
  }

  getClassPratica(idTipoPratica) {
    return CssClassMapping.cssTipiPratica[idTipoPratica];
  }

  getCssClassCategoriaFascicolo(fascicolo: FascicoloLight) {
    let categoriaMap = CssClassMapping.cssTipiCategoriaFascicolo[fascicolo.tipoFascicolo.categoria.id];
    return categoriaMap;
  }

  private getFascicoloFromMap(idTipoFascicoloMap: any, idTipoPraticaMap: any) {
    // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[idTipoFascicoloMap];
    // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPraticaMap];
    let fascicolo = getFascicoloMapSync(idTipoPraticaMap, idTipoFascicoloMap);
    return fascicolo;
  }

  private getPraticaFromMap(idTipoPraticaMap: any) {
    // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPraticaMap];
    let pratica = getPraticaMapSync(idTipoPraticaMap);
    return pratica;
  }
  close() {
      this.dataInizioPratica = null;
      this.pratica = new PraticaBase();
      this.fascicoli = [];
      closeModal('modalCopiaPratica');
  }
}
